module.exports = __webpack_public_path__ + "img/ICONO_REPLICA.b8def8df.png";